import { EcommerceEvent, SiteColors } from './types';

export const getSiteColors = (): SiteColors => {
    return {
        Primary: '#6C757D',
        Secondary: '#F5922D',
        Tertiary: '#343A40',
        Quaternary: '#C1C8E4',
        Quinary: '#8860D0'
    }
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const pushEcommercePurchaseEvent = (ecommerce: EcommerceEvent) => {
    // Tracking is best-effort: a misbehaving GTM tag/trigger throwing on push()
    // should never break the confirmation page for the user.
    try {
        if (!window.dataLayer) {
            return;
        }

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'purchase',
            ecommerce
        });
    } catch (error) {
        console.error(error);
    }
}